export var gql = function gql(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return strings.map(function (string, i) {
    return string + (values[i] || '');
  }).join('').trim();
};